import { createAction } from 'redux-act';
import { ISelectionCleanUpAction } from '../types/selections';

export const fetchSelections = createAction();

export const selectionCleanUp = createAction<ISelectionCleanUpAction>();
export const selectionCleanUpSuccess = createAction<boolean>();
